import { render, staticRenderFns } from "./crudCategory.vue?vue&type=template&id=dcd303be&scoped=true&"
import script from "./crudCategory.vue?vue&type=script&lang=js&"
export * from "./crudCategory.vue?vue&type=script&lang=js&"
import style0 from "./crudCategory.vue?vue&type=style&index=0&id=dcd303be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd303be",
  null
  
)

export default component.exports